import React, { useState, useMemo } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from 'react-router-dom'

import queryString from 'query-string'

import {
  Grid, IconButton, Typography, Card, CardContent, CardActionArea, Avatar,
  Button, CardHeader, TextField, Chip, Dialog,
  DialogTitle as MuiDialogTitle, DialogContent as MuiDialogContent,
  Select, FormControl, InputLabel, MenuItem, Fab, Tooltip
} from '@material-ui/core'

import { makeStyles, withStyles, fade } from '@material-ui/core/styles'

import CloseIcon from '@material-ui/icons/Close'
import ClearIcon from '@material-ui/icons/Clear'

import { Toast as NotificationToast } from '../tools/Toast'
import { ConfirmToast, QuarantineSubBanner } from '../tools'

import { shareViolations } from '../../../redux/actions'

import GroupSupervisorDialog from '../tools/GroupSupervisorDialog'

import log from 'loglevel'
import { setAllChecked } from '../../../redux/actions/select'
import { getViolationIndex } from '../../../utils'
import { toggleImage } from '../../../utils/functions/toggleFunctions'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1050 !important'
  },
  sharePaper: {
    width: '60em'
  },
  shareBar: {
    borderRadius: '0.15em',
    backgroundColor: '#3984f7'
  },
  closeBtn: {
    color: '#ffffff'
  },
  userListContainer: {
    overflow: 'hidden',
    height: '14.75em',
    // marginTop: '0.25em',
    border: '2px dashed #3984f7',
    backgroundColor: theme.palette.background.paper
  },
  groupListContainer: {
    // marginBottom: '0.25em',
    overflow: 'hidden',
    height: '14.75em',
    border: '2px dashed #A4D164',
    backgroundColor: theme.palette.background.default
  },
  listContainer: {
    height: '36em'
  },
  listPaper: {
    width: '100%'
  },
  groupAvatar: {
    width: '2em',
    height: '2em'
  },
  avatarGroup: {
    height: '2em',
    width: '2em'
  },
  groupCard: {
    // width: '10em',
    width: '100%',
    height: 'fit-content'
  },
  userCard: {
    height: 'fit-content',
    width: '100%',
    marginBottom: '.5rem'
  },
  groupHeader: {
    padding: theme.spacing(2, 2, 0)
  },
  groupContent: {
    height: '85%',
    overflow: 'scroll',
    width: '100%'
  },
  userHeader: {
    padding: theme.spacing(2, 2, 0)
  },
  userContent: {
    overflow: 'scroll',
    height: '85%',
    width: '100%'
  },
  userSelected: {
    // border: '2px solid #0651C4'
    backgroundColor: 'rgba(6, 81, 196, 0.2)'
  },
  groupSelected: {
    backgroundColor: 'rgba(164, 209, 100, 0.2)'
  },
  cardHeader: {
    paddingTop: '16px',
    paddingBottom: '0px',
    paddingRight: '16px',
    paddingLeft: '16px',
    // fontWeight: 'bold',
    fontSize: '1.2rem',
    color: '#6d6d6d'
  },
  messageCard: {
    backgroundColor: theme.palette.background.default,
    height: '100%',
    overflow: 'scroll',
    border: '2px dashed #A4D164'
  },
  firstContainer: {
    // height: '20em',
    margin: 'auto'
  },
  messageContent: {
  },
  violationCard: {
    border: '2px dashed #3984f7',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default
  },
  violationImgCard: {
    width: '100%',
    height: 'fit-content'
  },
  violationContent: {
    height: '16.25em',
    width: '100%',
    overflow: 'scroll'
  },
  violationHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  violationImg: {
    width: '100%',
    // paddingTop: '100%',
    height: '100%',
    margin: 'auto 0'
    // backgroundSize: 'contain'
  },
  countAvatar: {
    backgroundColor: '#3984f7',
    color: '#fff',
    width: '1.5em',
    height: '1.5em'
  },
  newStatus: {
    borderBottom: '7px solid #CB9BFF'
  },
  problemStatus: {
    borderBottom: '7px solid #FFA593'
  },
  noProblemStatus: {
    borderBottom: '7px solid #96E1A8'
  },
  holdStatus: {
    borderBottom: '7px solid #ffff91'
  },
  solvedStatus: {
    borderBottom: '7px solid #A6FFFF'
  },
  changedStatus: {
    borderBottom: '7px solid #ffa500'
  },
  supervisorWrap: {
    flexWrap: 'nowrap'
  },
  supervisorChip: {
    // backgroundColor: '#A4D164',
    margin: theme.spacing(0.5)
    // color: '#fff'
  },
  groupChip: {
    // backgroundColor: '#3984f7',
    margin: theme.spacing(0.5)
  },
  groupChipAvatar: {
    backgroundColor: 'rgba(6, 81, 196, 0.5)',
    color: '#fff !important'
  },
  viewBtn: {
    color: '#A4D164',
    fontWeight: 700
  },
  groupAction: {
    '&:focus': {
      outline: 'none'
    }
  },
  supervisorAction: {
    '&:focus': {
      outline: 'none'
    }
  },
  groupList: {
    // maxHeight: '22.5em',
    overflowX: 'hidden',
    overflowY: 'scroll',
    minWidth: '20em'
  },
  groupDivider: {
    height: '0.1em'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#ffffff'
  },
  shareDialog: {
    height: '100vh'
  },
  dialogTitle: {
    backgroundColor: '#3984F7'
  },
  dialogText: {
    color: '#ffffff'
  },
  shareButton: {
    backgroundColor: '#3984F7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    marginRight: '.5rem',
    marginBottom: '.5rem'
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '100%',
    marginLeft: 'auto',
    marginBottom: '.5rem'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  }
}))

const useSelectStyles = makeStyles((theme) => ({
  select: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    '&:focus': {
      backgroundColor: '#f5f5f5'
    },
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

const ShareModal = (props) => {
  const { open, toggleModal, handleClickStatus = () => {}, handleGetViolationInfo = () => {} } = props

  const dispatch = useDispatch()
  const classes = useStyles()
  const selectClasses = useSelectStyles()
  const textClasses = useTextStyles()

  const { availableUsers, availableGroups, availableTemplates } = useSelector(state => state.groups)

  const Captures = useSelector(state => state.violations.violations.captures)
  const PageLimit = useSelector(state => state.selection.PageCaptureLimit)
  const currentSupervisorEmail = useSelector(state => state.auth.username)
  const currentSupervisorFirstName = useSelector(state => state.auth.firstName)
  const currentSupervisorLastName = useSelector(state => state.auth.lastName)

  const fullName = `${currentSupervisorFirstName} ${currentSupervisorLastName}`

  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })

  const [userList, setUserList] = useState([])
  const [groupList, setGroupList] = useState([])
  const [supervisors, setSupervisors] = useState([])
  const [groups, setGroups] = useState([])

  const [selectedTemplate, setSelectedTemplate] = useState('')

  const [shareSubject, setShareSubject] = useState('')
  const [shareMessage, setShareMessage] = useState('')
  const [shareIssue, setShareIssue] = useState('')
  const [shareFooter, setShareFooter] = useState(`Thanks, \n\n${fullName}`)

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageLimit])

  useMemo(() => { setUserList(availableUsers) }, [availableUsers])

  useMemo(() => { setGroupList(availableGroups) }, [availableGroups])

  // function to add / remove a supervisor
  const handleSupervisorClick = (supervisorID) => {
    const currentSupervisors = [...supervisors]
    const supervisorIndex = currentSupervisors.findIndex((elSupervisor) => elSupervisor === supervisorID)

    if (supervisorIndex !== -1) {
      currentSupervisors.splice(supervisorIndex, 1)
    } else {
      currentSupervisors.push(supervisorID)
    }

    setSupervisors(currentSupervisors)
  }

  // function to add / remove a group
  const handleGroupClick = (groupID) => {
    const currentGroups = [...groups]
    const groupIndex = currentGroups.findIndex((elGroup) => elGroup === groupID)

    if (groupIndex !== -1) {
      currentGroups.splice(groupIndex, 1)
    } else {
      currentGroups.push(groupID)
    }

    setGroups(currentGroups)
  }

  const checkSupervisor = (supervisorID) => {
    const supervisorIndex = supervisors.findIndex((elSupervisor) => elSupervisor === supervisorID)

    if (supervisorIndex !== -1) {
      return classes.userSelected
    } else {
      return ''
    }
  }

  const checkGroup = (groupID) => {
    const groupIndex = groups.findIndex((elGroup) => elGroup === groupID)

    if (groupIndex !== -1) {
      return classes.groupSelected
    } else {
      return ''
    }
  }

  // function to set a selected template
  const handleTemplateChange = (type) => {
    switch (type) {
      case 'Potential Issue - School Device': {
        setSelectedTemplate('Potential Issue - School Device')
        break
      }
      case 'Potential Issue - Personal Device': {
        setSelectedTemplate('Potential Issue - Personal Device')
        break
      }
      case 'Child Pornography - School Device': {
        setSelectedTemplate('Child Pornography - School Device')
        break
      }
      case 'Child Pornography - Personal Device': {
        setSelectedTemplate('Child Pornography - Personal Device')
        break
      }
      default: break
    }
  }

  const templateSwitch = () => {
    switch (selectedTemplate) {
      case 'Potential Issue - School Device': {
        const template = availableTemplates.find(template => template.templateID === 'STB560567A4AC311EBB3780242AC130002')
        setShareSubject(template.subject)
        setShareMessage(template.body)
        setSelectedTemplate('')
        break
      }
      case 'Potential Issue - Personal Device': {
        const template = availableTemplates.find(template => template.templateID === 'STB56057564AC311EBB3780242AC130002')
        setShareSubject(template.subject)
        setShareMessage(template.body)
        setSelectedTemplate('')
        break
      }
      case 'Child Pornography - School Device': {
        const template = availableTemplates.find(template => template.templateID === 'STB560536E4AC311EBB3780242AC130002')
        setShareSubject(template.subject)
        setShareMessage(template.body)
        setSelectedTemplate('')
        break
      }
      case 'Child Pornography - Personal Device': {
        const template = availableTemplates.find(template => template.templateID === 'STB560558A4AC311EBB3780242AC130002')
        setShareSubject(template.subject)
        setShareMessage(template.body)
        setSelectedTemplate('')
        break
      }
      default: break
    }
  }

  const handleTemplateSet = async () => {
    if (shareSubject.length > 0 || shareMessage.length > 0 || shareIssue.length > 0) {
      const confirmTemplate = await ConfirmToast({ msg: 'Are you sure you want to apply this template?', txt: 'This will overwrite changes already made.' })
      if (confirmTemplate) {
        templateSwitch()
      }
    } else {
      templateSwitch()
    }
  }

  const getStatusClass = (status) => {
    switch (status) {
      case 'U': return classes.newStatus
      case 'P': return classes.problemStatus
      case 'N': return classes.noProblemStatus
      case 'H': return classes.holdStatus
      case 'S': return classes.solvedStatus
      case 'C': return classes.changedStatus
      default: return null
    }
  }

  // function to handle sharing a violation
  const handleShareViolation = async () => {
    if (shareSubject && shareMessage) {
      const activeViolations = handleGetViolationInfo()

      if ((Boolean(groups.length) || Boolean(supervisors.length)) && Boolean(activeViolations.length)) {
        const allSupervisors = []
        groups.forEach((groupID) => {
          const groupInfo = groupList.find((group) => group.groupID === groupID)

          if (groupInfo) {
            allSupervisors.push(...groupInfo.supervisors.map((supervisorInfo) => ({ supervisorID: supervisorInfo.supervisorID })))
          }
        })

        supervisors.forEach((supervisorID) => allSupervisors.push({ supervisorID }))

        const filterSupervisors = []

        allSupervisors.forEach((supervisorInfo) => {
          const supervisorIndex = filterSupervisors.findIndex((elSupervisor) => elSupervisor.supervisorID === supervisorInfo.supervisorID)

          // if (supervisorIndex === -1 && supervisorInfo.supervisorID !== currentSupervisor) { filterSupervisors.push(supervisorInfo) }
          if (supervisorIndex === -1) { filterSupervisors.push(supervisorInfo) }
        })

        if (filterSupervisors.length) {
          const message = {
            sender: currentSupervisorEmail,
            senderName: fullName,
            subject: shareSubject,
            message: shareMessage,
            issue: shareIssue,
            footer: shareFooter
          }

          dispatch(shareViolations(activeViolations, filterSupervisors, message, fireShareSuccess, fireShareFailure))

          // find violations with unviewed status, then create array of those violationIDs and pass them to click status function
          const filteredArray = activeViolations.filter(violation => violation.statusFlag === 'U')
          const sharedArray = filteredArray.map(violation => {
            return violation.violationID
          })
          if (sharedArray.length > 0) {
            handleClickStatus('P', sharedArray)
          }
          // if (setToProblem) {
          //   handleClickStatus('P')
          // }

          setShareSubject('')
          setShareMessage('')
          setShareIssue('')
          setSelectedTemplate('')
          setGroups([])
          setSupervisors([])
        } else {
          log.info('this should not be happening')
        }
      } else {
        NotificationToast(false, 'Must select at least a group or supervisor to share with!', true)
      }
    } else {
      NotificationToast(false, 'Message fields are empty!', true)
    }
  }

  const fireShareSuccess = () => {
    NotificationToast(false, `Successfully shared violation${limiter}!`)
    setShareSubject('')
    setShareMessage('')
    setGroups([])
    setSupervisors([])
    dispatch(setAllChecked(false))
    toggleModal()

    if (parsedProps.view === 'grid') {
      props.history.push({
        pathname: '/captures',
        search: `?view=grid&page=${parsedProps.page}&activeCaptures=[]`
      })
    }
  }

  const fireShareFailure = () => {
    NotificationToast(true, `Failed to share violation${limiter}`)
  }

  const handleClose = () => {
    setShareSubject('')
    setShareMessage('')
    setShareIssue('')
    setSelectedTemplate('')
    setGroups([])
    setSupervisors([])
    toggleModal()
  }

  const getActiveViolations = () => {
    if (parsedProps.view !== 'grid' && typeof parsedProps.captureTrgts === 'number') {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })
      const captureInfo = (() => {
        if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
        return {}
      })()

      if (captureInfo && Boolean(captureInfo.violationID)) {
        const { quarantined, redacted } = captureInfo
        return (
          <Grid container item direction='row' className='mx-auto w-100 mb-2' key={`share-violation-${captureInfo.violationID}`}>
            <Card raised className={`${classes.violationImgCard} ${getStatusClass(captureInfo.statusFlag)}`}>
              {toggleImage(captureInfo, false, `nogrid-img-${captureInfo.violationID}`, classes.violationImg)}
              {quarantined && <QuarantineSubBanner redacted={redacted} fontSize={14} />}
            </Card>
          </Grid>
        )
      }
    }

    if (parsedProps.view === 'grid' && Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length)) {
      const activeViolations = parsedProps.captureTrgts.reduce((arr, captureNum) => {
        const captureIx = getViolationIndex({ captureNum, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })
        const captureInfo = (() => {
          if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          arr.push(
            <Grid container item direction='row' className='mx-auto w-100 mb-2' key={`share-violation-${captureInfo.violationID}`}>
              <Card raised className={`${classes.violationImgCard} ${getStatusClass(captureInfo.statusFlag)}`}>
                {toggleImage(captureInfo, false, `grid-img-${captureInfo.violationID}`, classes.violationImg)}
              </Card>
            </Grid>
          )
        }

        return arr
      }, [])

      if (activeViolations.length) { return activeViolations }
    }

    return (<></>)
  }

  const limiter = Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length) && parsedProps.captureTrgts.length > 1 ? 's' : ''

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={`${classes.shareDialog} filterModal`}
      fullWidth maxWidth='lg'
    >
      <MuiDialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant='h4' color='primary' classes={{ colorPrimary: classes.dialogText }} className='font-weight-bold'>Share Violation{limiter}</Typography>
        <IconButton aria-label='close' className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>

      <MuiDialogContent dividers className={classes.shareDialog}>
        <Grid item container direction='column' xs={12}>
          <Grid container item direction='row' justify='flex-end'>
            <Button
              variant='contained'
              className={classes.shareButton}
              disabled={parsedProps.captureTrgts == null || (Array.isArray(parsedProps.captureTrgts) && !parsedProps.captureTrgts.length)}
              onClick={handleShareViolation}
            >
              Share Violation{limiter}
            </Button>
          </Grid>

          <Grid container item direction='row' alignItems='center' className={`${classes.listContainer} w-100 m-auto`}>
            <Grid container item direction='column' justify='space-evenly'>
              <Grid container item direction='row' spacing={2} className={`mx-auto w-100 ${classes.firstContainer}`} justify='flex-end'>
                {/* First Container (Start) */}
                <Grid item xs={4} container direction='column'>
                  {/* Violation List (Start) */}
                  <Grid item container direction='row' style={{ height: '19rem' }}>
                    <Card className={`mx-auto w-100 h-100 ${classes.violationCard}`} raised>
                      <CardHeader
                        title={
                          <Grid container direction='row' justify='space-between' alignItems='center'>
                            <Grid item>
                              <Typography className={classes.cardHeader}>Violation{limiter}</Typography>
                            </Grid>
                            <Grid item>
                              <Avatar className={classes.countAvatar}>
                                {Array.isArray(parsedProps.captureTrgts) ? parsedProps.captureTrgts.length : typeof parsedProps.captureTrgts === 'number' ? 1 : 0}
                              </Avatar>
                            </Grid>
                          </Grid>
                        }
                        disableTypography
                        className={classes.violationHeader}
                      />
                      <CardContent className={classes.violationContent}>
                        <Grid container direction='column' alignItems='center' className='mx-auto w-100'>
                          {getActiveViolations()}
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  {/* Violation List (End) */}

                  {/* Share List (Start) */}
                  <Grid item container direction='row' style={{ height: '21rem', marginTop: '3rem' }}>
                    <Card className={`h-100 w-100 ${classes.groupListContainer}`} raised>
                      <CardHeader
                        title={
                          <Grid container direction='row' alignItems='center'>
                            <Grid item xs={8}>
                              <Grid item container direction='row' justify='flex-start'>
                                <Typography className={classes.cardHeader}>Share With...</Typography>
                              </Grid>
                            </Grid>
                            <Grid item xs={4}>
                              <Grid item container direction='row' justify='flex-end' alignItems='center'>
                                {
                                  supervisors.length > 0
                                    ? (
                                      <>
                                        <LightTooltip title='Clear All Selected' placement='top' arrow>
                                          <Fab
                                            className={classes.searchBtn}
                                            size='small'
                                            onClick={(e) => { e.preventDefault(); setSupervisors([]) }}
                                          >
                                            <ClearIcon />
                                          </Fab>
                                        </LightTooltip>
                                      </>)
                                    : (
                                      <>
                                      </>)
                                }
                              </Grid>
                            </Grid>
                            {/* {
                              searchOpen === true
                                ? (
                                  <>
                                    <Grid item xs={4}>
                                      <Grid item container direction='row'>
                                        <Grid item xs={6}>
                                          <Typography>Supervisors</Typography>
                                          <GreenCheckbox
                                            checked={searchOpen === true}
                                            size='small'
                                            onClick={(e) => e.preventDefault()}
                                          />
                                        </Grid>
                                        <Grid item xs={6}>
                                          <Typography>Groups</Typography>
                                          <GreenCheckbox
                                            checked={searchOpen === true}
                                            size='small'
                                            onClick={(e) => e.preventDefault()}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <div className={classes.search}>
                                        <div className={classes.searchIcon}>
                                          <Fab
                                            className={classes.searchBtn}
                                            size='small'
                                          >
                                            <SearchIcon />
                                          </Fab>
                                        </div>
                                        <InputBase
                                          placeholder='Search...'
                                          classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput
                                          }}
                                          inputProps={{ 'aria-label': 'search' }}
                                          onChange={(e) => {
                                            setSearchVal(e.target.value)
                                          }}
                                          value={searchVal}
                                          endAdornment={
                                            <InputAdornment position='start'>
                                              <IconButton onClick={(e) => { e.preventDefault(); setSearchVal(''); setSearchOpen(false) }}>
                                                <ClearIcon />
                                              </IconButton>
                                            </InputAdornment>
                                          }
                                        />
                                      </div>
                                    </Grid>
                                  </>
                                ) : (
                                  <>
                                    <Grid item xs={8}>
                                      <Grid item container direction='row' justify='flex-start'>
                                        <Typography className={classes.cardHeader}>Share With...</Typography>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Grid item container direction='row' justify='flex-end' alignItems='center'>
                                        <Fab
                                          className={classes.searchBtn}
                                          size='small'
                                          onClick={(e) => { e.preventDefault(); setSearchOpen(true) }}
                                        >
                                          <SearchIcon />
                                        </Fab>
                                      </Grid>
                                    </Grid>
                                  </>
                                )
                            } */}
                          </Grid>
                        }
                        disableTypography
                        className={classes.violationHeader}
                      />
                      <CardContent className={classes.groupContent}>
                        <Grid container direction='column' alignItems='center' className='w-100 mx-auto'>
                          {
                            groupList.sort((a, b) => typeof a === 'object' && Boolean(a.groupName) && a.groupName.localeCompare(b.groupName)).reduce((arr, groupInfo) => {
                              if (typeof groupInfo === 'object' && Boolean(groupInfo.groupID)) {
                                arr.push(
                                  <GroupSupervisorDialog
                                    groupInfo={groupInfo}
                                    key={`group-${groupInfo.groupID}`}
                                    classes={classes}
                                    checkGroup={checkGroup}
                                    handleGroupClick={handleGroupClick}
                                  />

                                )
                              }
                              return arr
                            }, [])
                          }
                          {
                            userList.sort((a, b) => typeof a === 'object' && Boolean(a.lastName) && a.lastName.localeCompare(b.lastName)).reduce((arr, userInfo) => {
                              if (typeof userInfo === 'object' && Boolean(userInfo.supervisorID) && Boolean(userInfo.firstName)) {
                                arr.push(
                                  <Grid item xs={12} container direction='row' className='w-100 mx-auto' key={`share-${userInfo.supervisorID}`}>
                                    <Card raised className={`${classes.userCard} ${checkSupervisor(userInfo.supervisorID)}`}>
                                      <CardActionArea onClick={() => handleSupervisorClick(userInfo.supervisorID)} className={classes.supervisorAction}>
                                        <CardHeader
                                          avatar={
                                            <Avatar src={userInfo.avatarPath} className={classes.groupAvatar}>
                                              {userInfo.avatarPath ? (<></>) : userInfo.firstName.substring(0, 1)}{userInfo.lastName.substring(0, 1)}
                                            </Avatar>
                                          }
                                          title={`${userInfo.firstName} ${userInfo.lastName}`}
                                          titleTypographyProps={{ variant: 'button' }}
                                        />
                                      </CardActionArea>
                                    </Card>
                                  </Grid>
                                )
                              }

                              return arr
                            }, [])
                          }
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  {/* Share List (End) */}
                </Grid>
                {/* First Container (End) */}

                {/* Message Info (Start) */}
                <Grid item xs={8} container direction='column'>
                  <Card className={`mx-auto w-100 ${classes.messageCard}`} raised>
                    <CardHeader title='Message Content' className={classes.cardHeader} />
                    <CardContent className={`${classes.messageContent} pb-0`}>
                      <Grid container direction='column' spacing={2} className='mx-auto w-100 my-auto h-100'>

                        {/* Template (Start) */}
                        <Grid item container direction='row' className='mx-auto w-100 pb-0 my-auto' alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>Template:</Typography>
                          </Grid>

                          <Grid item xs={7} container direction='row' className='mx-auto h-100 mb-2'>
                            <Grid container item direction='row'>
                              <FormControl fullWidth>
                                <InputLabel htmlFor='subject-type-label' variant='filled'>Template</InputLabel>
                                <Select
                                  labelId='subject-type-label'
                                  variant='filled'
                                  onChange={(e) => { e.preventDefault(); handleTemplateChange(e.target.value) }}
                                  classes={selectClasses}
                                  value={selectedTemplate}
                                >
                                  <MenuItem value='Potential Issue - School Device'>Potential Issue - School Device</MenuItem>
                                  <MenuItem value='Potential Issue - Personal Device'>Potential Issue - Personal Device</MenuItem>
                                  <MenuItem value='Child Pornography - School Device'>Child Pornography - School Device</MenuItem>
                                  <MenuItem value='Child Pornography - Personal Device'>Child Pornography - Personal Device</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>

                          <Grid item xs={3}>
                            <Grid item container direction='row' justify='flex-end'>
                              <Button
                                className={classes.greenBtn}
                                disabled={selectedTemplate === ''}
                                onClick={(e) => { e.preventDefault(); handleTemplateSet() }}
                              >
                                Use Template
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Template (End) */}

                        {/* To (Start) */}
                        <Grid item container direction='row' className={`mx-auto w-100 pb-0 my-auto ${classes.supervisorContainer}`} alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>To:</Typography>
                          </Grid>

                          <Grid item xs={10} container style={{ maxHeight: '5rem', overflowY: 'scroll' }}>
                            <Grid container item direction='row' alignItems='center'>
                              {
                                groups.length === 0 && supervisors.length === 0
                                  ? (<Typography variant='h6'>No Supervisors or Groups Selected</Typography>)
                                  : (<></>)
                              }
                              {
                                groups.map((groupID) => {
                                  const groupInfo = groupList.find((group) => group.groupID === groupID)
                                  if (groupInfo) {
                                    return (
                                      <Chip
                                        size='medium'
                                        label={groupInfo.groupName}
                                        avatar={<Avatar className={classes.groupChipAvatar}>{groupInfo.supervisors.length}</Avatar>}
                                        className={`${classes.groupChip}`}
                                        key={`group-chip-${groupID}`}
                                      />
                                    )
                                  } else {
                                    return (<React.Fragment key='null' />)
                                  }
                                })
                              }

                              {
                                supervisors.reduce((arr, supervisorID) => {
                                  if (typeof supervisorID === 'string') {
                                    const supervisorInfo = userList.find((user) => typeof user === 'object' && Boolean(user.supervisorID) && user.supervisorID === supervisorID)

                                    if (typeof supervisorInfo === 'object' && Boolean(supervisorInfo.firstName)) {
                                      arr.push(
                                        <Chip
                                          size='medium'
                                          key={`supervisor-chip-${supervisorID}`}
                                          label={`${supervisorInfo.firstName} ${supervisorInfo.lastName}`}
                                          avatar={
                                            <Avatar src={supervisorInfo.avatarPath}>
                                              {supervisorInfo.avatarPath ? (<></>) : supervisorInfo.firstName.substring(0, 1)}{supervisorInfo.lastName.substring(0, 1)}
                                            </Avatar>
                                          }
                                          className={`${classes.supervisorChip}`}
                                        />
                                      )
                                    }
                                  }

                                  return arr
                                }, [])
                              }
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* To (End) */}

                        {/* From (Start) */}
                        <Grid item container direction='row' className='mx-auto w-100 pb-0 my-auto' alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>From:</Typography>
                          </Grid>

                          <Grid item xs={10} container direction='row' className='mx-auto h-100 mb-2'>
                            <Grid container item direction='row'>
                              <TextField
                                fullWidth
                                // label='Subject Footer'
                                name='shareFrom'
                                variant='filled'
                                InputProps={{
                                  classes: textClasses
                                }}
                                value={currentSupervisorEmail}
                                disabled
                              // onChange={(e) => setSubjectFooter(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* From (End) */}

                        {/* <Grid item container direction='row' className='mx-auto w-100 py-0'>
                          <Typography variant='body1' className=''>Subject</Typography>
                        </Grid>
                        <Grid item container direction='row' className='mx-auto w-100 pt-0'>
                          <Grid container item xs={4} direction='row' className='mx-auto w-100'>
                            <FormControl fullWidth>
                              <InputLabel htmlFor='subject-type-label' variant='filled'>Subject Type</InputLabel>
                              <Select
                                labelId='subject-type-label'
                                variant='filled'
                                onChange={(e) => handleTemplateChange(e.target.value)}
                                classes={selectClasses}
                                value={subjectType}
                              >
                                <MenuItem value='R&C'>Review And Comment</MenuItem>
                                <MenuItem value='R&S'>Review And Give Status</MenuItem>
                                <MenuItem value='R&R'>Review And Resolve</MenuItem>
                                <MenuItem value='R'>Review</MenuItem>
                                <MenuItem value='other'>Other</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid container item xs={8} direction='row' className='mx-auto w-100'>
                            <TextField
                              fullWidth
                              label='Subject Header'
                              name='subjectMsg'
                              variant='filled'
                              InputProps={{
                                classes: textClasses
                              }}
                              onChange={(e) => setSubjectHeader(e.target.value)}
                              value={subjectHeader}
                              disabled={subjectType !== 'other'}
                            />
                          </Grid>
                        </Grid> */}

                        {/* Subject (Start) */}
                        <Grid item container direction='row' className='mx-auto w-100 pb-0 my-auto' alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>Subject:</Typography>
                          </Grid>

                          <Grid item xs={10} container direction='row' className='mx-auto h-100 mb-2'>
                            <Grid container item direction='row'>
                              <TextField
                                fullWidth
                                label='Subject'
                                name='shareSubject'
                                variant='filled'
                                InputProps={{
                                  classes: textClasses
                                }}
                                value={shareSubject}
                                onChange={(e) => setShareSubject(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Subject (End) */}

                        {/* Message Body (Start) */}
                        <Grid item container direction='row' className='mx-auto w-100 pb-0 my-auto' alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>Message:</Typography>
                          </Grid>

                          <Grid item xs={10} container direction='row' className='mx-auto h-100 mb-2'>
                            <Grid container item direction='row'>
                              <TextField
                                fullWidth
                                label='Message'
                                name='shareMessage'
                                variant='filled'
                                multiline
                                rows={5}
                                InputProps={{
                                  classes: textClasses
                                }}
                                value={shareMessage}
                                onChange={(e) => setShareMessage(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Message Body (End) */}

                        {/* Issue (Start) */}
                        <Grid item container direction='row' className='mx-auto w-100 pb-0 my-auto' alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>Issue:</Typography>
                          </Grid>

                          <Grid item xs={10} container direction='row' className='mx-auto h-100 mb-2'>
                            <Grid container item direction='row'>
                              <TextField
                                fullWidth
                                label='Issue'
                                name='shareIssue'
                                variant='filled'
                                InputProps={{
                                  classes: textClasses
                                }}
                                value={shareIssue}
                                onChange={(e) => setShareIssue(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Issue (End) */}

                        {/* Footer (Start) */}
                        <Grid item container direction='row' className='mx-auto w-100 pb-0 my-auto' alignItems='center'>
                          <Grid item xs={2}>
                            <Typography variant='body1'>Footer:</Typography>
                          </Grid>

                          <Grid item xs={10} container direction='row' className='mx-auto h-100 mb-2'>
                            <Grid container item direction='row'>
                              <TextField
                                fullWidth
                                label='Footer'
                                name='shareFooter'
                                variant='filled'
                                multiline
                                rows={3}
                                InputProps={{
                                  classes: textClasses
                                }}
                                value={shareFooter}
                                onChange={(e) => setShareFooter(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* Footer (End) */}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {/* Message Info (End) */}
              </Grid>

            </Grid>
          </Grid>
        </Grid>
      </MuiDialogContent>
      {/* </Fade> */}
    </Dialog>
  )
}

export default withRouter(ShareModal)
